import axios from "axios";

const http = axios.create({
  baseURL: '',
  timeout: 30000,
  withCredentials: true

});

// http.defaults.headers['userSession'] = sessionStorage.getItem("sessionId");

http.interceptors.request.use(
  request => {
    request.headers['userSession'] = sessionStorage.getItem("sessionId");
    return request;
  }
);


http.interceptors.response.use(
  response => {
    if (response.data.errCode === 0) {
      return response.data.data;
    } else {
      // window.$vm.$Message.error(response.data.errMsg);
    }
    // window.$vm.$Message.error(response.data.errMsg);
    return Promise.reject(response.data);
  },

  error => {
    const code = error.response.status;

    switch (code) {
      case 401:
        window.$vm.$Message.error("您还没有登录，请先登录！");
        break;
      case 500:
        window.$vm.$Message.error("服务维护中，请稍后再试");
      case 408:
        window.$vm.$Message.error("服务请求超时");
        break;
      default:
        window.$vm.$Message.error(error.response.data.errMsg);
        break;
    }
    return Promise.reject(error);
  }
);

export default http;
